import { useHistory, useReconcile } from '../../api/hooks';
import { Button, DataTable, JsonBlock, Loading, PageHeader, RelativeTime } from '../../ui';
import { useEventStream } from '../../realtime/useEventStream';
import { useParams } from 'react-router-dom';

export function ActivityPage(): JSX.Element {
  const { botId, channelId } = useParams();
  const history = useHistory(botId, channelId);
  const live = useEventStream({ enabled: true, filters: { botId, broadcasterUserId: channelId } });
  if (history.isPending) return <Loading />;
  return (
    <>
      <PageHeader title="Activité" eyebrow={live.status === 'open' ? 'flux live' : live.status} />
      <DataTable
        rows={[
          ...live.events.map((e) => ({
            kind: 'eventsub' as const,
            id: e.id,
            type: e.type,
            botId: e.botId,
            broadcasterUserId: e.broadcasterUserId,
            occurredAt: e.occurredAt,
            payload: e.payload,
          })),
          ...(history.data ?? []),
        ]}
        empty="Aucun événement."
        columns={[
          { key: 'k', header: 'Kind', cell: (r) => r.kind },
          { key: 't', header: 'Type', cell: (r) => r.type ?? ('endpoint' in r ? r.endpoint : '—') },
          { key: 'w', header: 'Quand', cell: (r) => <RelativeTime value={r.occurredAt ?? ('createdAt' in r ? r.createdAt : undefined)} /> },
          { key: 'p', header: '', cell: (r) => <JsonBlock value={r.payload ?? r} /> },
        ]}
      />
    </>
  );
}

export function EventSubPage(): JSX.Element {
  const reconcile = useReconcile();
  const history = useHistory();
  return (
    <>
      <PageHeader
        title="EventSub"
        actions={<Button variant="primary" loading={reconcile.isPending} onClick={() => reconcile.mutate({})}>Réconcilier</Button>}
      />
      {history.isPending ? <Loading /> : (
        <DataTable
          rows={(history.data ?? []).filter((r) => r.kind === 'eventsub')}
          empty="Aucun événement EventSub."
          columns={[
            { key: 't', header: 'Type', cell: (r) => r.type },
            { key: 'b', header: 'Bot', cell: (r) => r.botId },
            { key: 'c', header: 'Broadcaster', cell: (r) => r.broadcasterUserId },
            { key: 'w', header: 'Quand', cell: (r) => <RelativeTime value={r.occurredAt} /> },
          ]}
        />
      )}
    </>
  );
}
